import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Icon from 'brandComponents/Icon';

import {IOrderDetailsGiftCardProps} from './IOrderDetailsGiftCard';
import messages from './messages';

const OrderDetailsGiftCardItem = ({classNames, GiftCardItem, currency}: IOrderDetailsGiftCardProps) => {
	const intl = useIntl();

	return (
		<div key={GiftCardItem.getItemId()} className={cn(classNames?.item, 'order-details__item')}>
			<Icon name="gift-certificate" width={90} height={125}/>
			<ul className="order-details__item__details gift-card">
				<li className="order-details__item__details-title">
					{intl.formatMessage((messages.itemName))}
				</li>
				<li>
					{intl.formatMessage(messages.giftcardAmount, {amount: GiftCardItem.getPrice(), currency: currency})}
				</li>
				<li>
					{intl.formatMessage(messages.sentTo, {recipient: GiftCardItem.getRecipientName()})}
				</li>
				<li>
					{intl.formatMessage(messages.email, {recipientEmail: GiftCardItem.getRecipientEmail()})}
				</li>
			</ul>
		</div>
	);
};

export default OrderDetailsGiftCardItem;
